import Pdf from './pdf';
import Html from './html';
import Toggler from './toggler';

export const PdfPreview = Pdf;
export const HtmlPreview = Html;
export const PreviewToggler = Toggler;